import type {AbstractHeaderCard, _AbstractHeaderCard} from './../common/abstract-header-card';
import type {CardResult} from './../card-result';
import type {Card} from './../card';

export namespace UnivariateHeaderCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.univariate_header.UnivariateHeaderCard$UnivariateHeaderCardResult
     */
    export interface UnivariateHeaderCardResult extends AbstractHeaderCard._AbstractHeaderCardResult {
        // PolyJson type
        type: 'univariate_header';
    }

    export namespace UnivariateHeaderCardResult {
        export const type = 'univariate_header';
    }

    /** @deprecated Use CardResult.isUnivariateHeaderCardResult() */ export function isUnivariateHeaderCardResult(toTest: CardResult): toTest is UnivariateHeaderCardResult { return UnivariateHeaderCardResult.type === toTest['type']; }
}

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.univariate_header.UnivariateHeaderCard
 */
export interface UnivariateHeaderCard extends _AbstractHeaderCard {
    showBoxPlot: boolean;
    showCumulativeDistributionFunction: boolean;
    showFrequencyTable: boolean;
    showHistogram: boolean;
    showQuantile: boolean;
    showSummary: boolean;

    // PolyJson type
    type: 'univariate_header';
}

export namespace UnivariateHeaderCard {
    export const type = 'univariate_header';
}

/** @deprecated Use Card.isUnivariateHeaderCard() */ export function isUnivariateHeaderCard(toTest: Card): toTest is UnivariateHeaderCard { return UnivariateHeaderCard.type === toTest['type']; }